export const VIEW_RECIPIENT_COPY_TITLE = 'View borrower copy';

export const PREVIEW_RECIPIENT_COPY_TITLE = 'Preview borrower copy';

export const PREVIEW_RECIPIENT_COPY_HEADER = 'Borrower copy preview';

export const PREVIEW_RECIPIENT_COPY_NOTICE = 'Preview — signing in progress, not a signed copy';
